import { PropsWithChildren } from 'react';
import { TooltipContentProps } from '@radix-ui/react-tooltip';
import { useTranslation } from '@sib/i18n';
import { Tooltip } from './Tooltip';

interface ComingSoonProps extends PropsWithChildren {
  tooltipText?: string;
  TooltipContentProps?: TooltipContentProps;
}

export const ComingSoon = ({
  children,
  tooltipText,
  TooltipContentProps,
}: ComingSoonProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      content={tooltipText || t('comingSoon')}
      TooltipContentProps={{
        variant: 'primary',
        ...TooltipContentProps,
      }}
    >
      {children}
    </Tooltip>
  );
};
